import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errText } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(errText(err, "Couldn't send the email. Try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell label="Account recovery" sub="We'll email you a one-time link to choose a new password. It works for one hour."
      heading={<>Locked out?<br />Happens to<br /><span className="italic text-primary">the best of us.</span></>}>
      <div>
        <h2 className="font-serif-display text-3xl mb-2">Reset your password</h2>
        <p className="text-sm text-muted-foreground">Remembered it? <Link to="/login" className="underline" data-testid="forgot-back-to-login">Log in</Link></p>
      </div>
      {sent ? (
        <div data-testid="forgot-sent" className="border border-foreground p-5 space-y-3">
          <p className="font-medium">Check your inbox</p>
          <p className="text-sm text-muted-foreground">
            If an account exists for <strong className="text-foreground">{email}</strong>, a reset link is on its way. It expires in 1 hour.
          </p>
          <button type="button" data-testid="forgot-change-email" onClick={() => setSent(false)} className="text-sm underline">Use a different email</button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6">
          <div>
            <Label htmlFor="email" className="font-mono-label">Email</Label>
            <Input id="email" data-testid="forgot-email" type="email" required autoFocus value={email}
              onChange={(e) => setEmail(e.target.value)} className="rounded-sm mt-1.5 h-11" />
          </div>
          <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full h-11 bg-foreground text-background hover:bg-primary rounded-sm btn-invert">
            {loading ? "Sending…" : "Email me a reset link →"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
